import { render, staticRenderFns } from "./DefaultH5.vue?vue&type=template&id=7f15d5d0&scoped=true&"
import script from "./DefaultH5.vue?vue&type=script&lang=js&"
export * from "./DefaultH5.vue?vue&type=script&lang=js&"
import style0 from "./DefaultH5.vue?vue&type=style&index=0&id=7f15d5d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f15d5d0",
  null
  
)

export default component.exports